import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer style={{
      background: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(20px)',
      padding: '2rem 0',
      borderTop: '1px solid rgba(148, 163, 184, 0.1)',
      marginTop: 'auto'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem',
        textAlign: 'center'
      }}>
        <p style={{
          marginBottom: '0.5rem',
          color: '#64748b',
          fontSize: '0.875rem',
          fontWeight: '400'
        }}>
          © 2024 MailService
        </p>
      </div>
    </footer>
  );
};

export default Footer;